<template>
  <div class="custom bg-[#23242A]">
      <div class="flex xl:flex-row flex-col px-4 pt-4 bg-[#23242A] text-white">
          <div class="transition-all duration-100 ease-linear custom-left mr-2" :class="(add || edit || grey)?'xl:w-[50%] w-full':'w-full'">
              <PurchaseOrderAddList @toggleAddEdit="toggleAddEdit" :split="add || edit || grey" />
          </div>
          <div v-if="add || edit || grey" class="xl:w-[60%] w-full custom-right transition-all duration-100 ease-linear">
              <!-- asn is in item for add-product -->
              <add-product v-if="add" @added="addedRow" :asn="asn" :item="editItem" :fulfillment="fulfillment" @toggleAddEdit="toggleAddEdit" @close="closeAdd" />
              <!-- addedRow - added stock from asn upload -->
              <edit-product v-if="edit" :asn="asn" :editItem="editItem" :fulfillment="fulfillment" :disabled="disabledEdit" @added="closeAddEdit" @close="closeEdit" @toggleAddEdit="toggleAddEdit" @updatedEditItem="updatedEditItem" />
              <!-- grey row - added stock from asn upload -->
              <grey-product v-if="grey" :asn="asn" :editItem="editItem" :fulfillment="fulfillment" @added="addedRow" @close="closeGrey" @toggleAddEdit="toggleAddEdit" />
            </div> 
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref} from "vue";
import PurchaseOrderAddList from '@/views/Products/PurchaseOrder/PurchaseOrderAdd/List.vue'
import addProduct from '@/views/Products/Product/Add/Add.vue'
import editProduct from '@/views/Products/Product/Edit/Edit.vue'
import GreyProduct from '@/views/Products/PurchaseOrder/GreyProduct/Edit.vue'

export default defineComponent({
    components: {
      PurchaseOrderAddList,
      addProduct,
      editProduct,
      GreyProduct
    },
    setup() {
      const add = ref(false)
      const edit = ref(false)
      const grey = ref(false)
      const asn = <any>ref({})
      const fulfillment = <any>ref(null)
      const editItem = <any>ref({})
      const disabledEdit = ref(false)

      return {add, edit, grey, asn, fulfillment, editItem, disabledEdit}
    },
    mounted(){
      this.emitter.on("closeAddEditInPurchaseOrder", this.closeAddEdit);
    },
    beforeDestroy() {
      this.emitter.off("closeAddEditInPurchaseOrder", this.closeAddEdit);
    },
    methods: {
      toggleAddEdit(status){
        this.editItem = status.editItem
        this.disabledEdit = status.disabled
        this.asn = status.asn
        this.fulfillment = status.fulfillment
        this.edit = status.edit
        this.add = status.add
        this.grey = status.grey
      },
      closeAdd(){
          this.add = false
      },
      closeEdit(){
          this.edit = false
      },
      closeGrey(){
        this.grey = false
        this.add = false
      },
      closeAddEdit(){
          this.add = false
          this.edit = false
          this.grey = false
      },
      updatedEditItem(item){
          this.editItem = item
      }
    }
  })
</script>